import { collection, getFirestore, query } from 'firebase/firestore';
import { firebaseApp } from '../../config/firebase.config';

const templateCollectionRef = () => query(collection(getFirestore(firebaseApp), `templates`));

export default templateCollectionRef;
